<div
  class="m-calendar"
  [ngClass]="{
    'week-resolution': resolution === 'week',
    'day-resolution': resolution !== 'week',
    'not-inline': !inline,
    'editing-endpoint': editingEndpoint,
    'flat-range': flatRange,
  }">
  <p-datepicker
    [ngModel]="value"
    (ngModelChange)="onInnerModelChange($event)"
    [view]="view"
    [dateFormat]="dateFormat"
    [readonlyInput]="readonlyInput"
    [inline]="inline"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [disabledDates]="disabledDates"
    [disabledDays]="disabledDays"
    [numberOfMonths]="numberOfMonths"
    [responsiveOptions]="responsiveOptions"
    [firstDayOfWeek]="firstDayOfWeek"
    [selectionMode]="selectionMode"
    [disabled]="$disabled()"
    [showIcon]="showIcon"
    [showOtherMonths]="showOtherMonths"
    [selectOtherMonths]="selectOtherMonths"
    (onMonthChange)="handleMonthChange($event)"
    (mouseover)="onHoverDate($event)"
    (onSelect)="onSelect.emit($event)"
    (onShow)="handleShow($event)"
    (keydown)="handleKeydown($event)"
    [appendTo]="appendTo()"
    [style]="$style"
    [showOnFocus]="showOnFocus">
  </p-datepicker>
</div>
